import { Component, OnInit, Output, Input, SimpleChanges, OnChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MemberlistService } from './service/memberlist.service';
import { Organization } from '../../org/orgedit/model/Organization';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { AuthorizationService } from '@src/app/helpers/authorization.service';
import { DatastoreService } from '@src/app/helpers/datastore/datastore.service';
import { PersonOrganization } from '@src/app/models/personorganization';
import { UieventhubService } from '@src/app/helpers/uieventhub/uieventhub.service';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-orgmemberlist',
  templateUrl: './orgmemberlist.component.html',
  styleUrls: ['./orgmemberlist.component.css']
})
export class OrgmemberlistComponent implements OnInit, OnChanges {
  @Output() members:PersonOrganization[] = [];
  @Output() modalpersonId:string;  
  @Output() modalorgId:string; 
  @Output() showSpinner:boolean;
  @Input() org:Organization;
  @Input() acceptedJoiner:PersonOrganization;
  constructor(
    private srv:MemberlistService,
    private route:ActivatedRoute,
    private auth:AuthorizationService,
    private datastore:DatastoreService,
    private uieventhub:UieventhubService,
    ) { }

  ngOnInit() {
   //this.uieventhub.addLoader('orgmemberlist');
    this.modalpersonId="";
    this.modalorgId = SessionHelper.getChoosenOrg();
    
    this.datastore.orgMembers$.pipe(untilDestroyed(this)).subscribe(j => {
   
      this.members = j;   
      setTimeout(()=>{this.showSpinner = false;},500);
    });
   //this.uieventhub.removeLoader('orgmemberlist');
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.org){
     this.members = this.datastore.orgMembers.getValue();  
    }
    
    if(changes.acceptedJoiner.currentValue){
      this.members.push(changes.acceptedJoiner.currentValue);
    }
  }
  updateList(personFromModal){
    //console.log('Update person list from modal data',personFromModal);
    if(personFromModal.date_left==""){
      this.members[this.members.findIndex(member => member.personId == personFromModal.personId)].member_function = personFromModal.member_function;
    }else{

      this.members.splice(this.members.findIndex(member => member.personId == personFromModal.personId),1);
    }
  }
  canAddMember(){
    return this.auth.isAuthorized('orgedit',SessionHelper.getChoosenOrg());
  }
  addNewMemberToList(newPersonOrg:PersonOrganization){
    this.members.push(newPersonOrg)
  }

  onClick(personId:string){
    this.modalpersonId = personId;
    //console.log('Id clicked: '+ this.modalpersonId);
  }
  toggleVisibility(i:number){
   if(this.members[i].show){
    this.members[i].show = false;
   }else{

    this.members[i].show = true;
   }
  }
}
